export default __webpack_public_path__ + "static/media/misc-fireplaceA-1024w.70a11c61.webp";